import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue";
import _imports_0 from '@/assets/images/ai-full-page.png';
const _hoisted_1 = {
  class: "video-card"
};
const _hoisted_2 = {
  class: "video-cover"
};
const _hoisted_3 = {
  key: 0,
  class: "error-cover"
};
const _hoisted_4 = {
  class: "error-reason"
};
const _hoisted_5 = {
  class: "background-blur"
};
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  key: 0,
  class: "background-blur"
};
const _hoisted_9 = {
  key: 3,
  class: "empty-cover"
};
const _hoisted_10 = {
  key: 4,
  class: "video-duration"
};
const _hoisted_11 = {
  key: 2,
  class: "video-progress"
};
const _hoisted_12 = {
  class: "generating-loading"
};
const _hoisted_13 = {
  class: "loading-text"
};
const _hoisted_14 = {
  class: "loading-tip"
};
const _hoisted_15 = {
  key: 3,
  class: "mask-actions"
};
const _hoisted_16 = {
  class: "popover-menu"
};
const _hoisted_17 = {
  class: "popover-menu"
};
const _hoisted_18 = {
  key: 5,
  class: "mask-actions"
};
const _hoisted_19 = {
  class: "popover-menu"
};
const _hoisted_20 = {
  class: "video-info"
};
const _hoisted_21 = {
  class: "video-title-container"
};
const _hoisted_22 = {
  class: "title-action-icons"
};
const _hoisted_23 = {
  class: "video-title"
};
const _hoisted_24 = {
  class: "video-date"
};
import { CircleCheck, VideoPlay, WarnTriangleFilled, CopyDocument, Download, Edit, Picture, Close } from '@element-plus/icons-vue';
import { formatMillisecondsToTimeNoMs } from '@/unit/medium';
import { ElProgress, ElInput, ElButton, ElPopover, ElText } from 'element-plus';
import 'element-plus/es/components/progress/style/index'
import 'element-plus/es/components/input/style/index'
import 'element-plus/es/components/button/style/index'
import 'element-plus/es/components/popover/style/index'
import 'element-plus/es/components/text/style/index'

import { ref } from 'vue';
// Props 定义
export default /*@__PURE__*/_defineComponent({
  __name: 'wArtworkCard',
  props: {
    videoItem: {},
    btnShow: {}
  },
  emits: ["clickFeatureFn"],
  setup(__props, {
    emit: __emit
  }) {
    const STATUS_MAP = {
      editing: '编辑中',
      processing: '生成中',
      success: '已完成',
      error: '生成失败'
    };
    // Props 类型定义
    const props = __props;
    // Emits 定义
    const emit = __emit;
    // 格式化日期，只显示年月日和时间（不显示秒）
    const formatDate = dateString => {
      if (!dateString) return '';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    };
    // 标题编辑相关
    const isEditingTitle = ref(false);
    const editingTitleValue = ref('');
    // 控制遮罩层和弹出框的状态
    const isHovering = ref(false);
    const isPopoverVisible = ref(false);
    // 开始编辑标题
    const startEditTitle = () => {
      editingTitleValue.value = props.videoItem.name || '';
      isEditingTitle.value = true;
    };
    // 统一事件处理函数
    const handleFeature = type => {
      emit('clickFeatureFn', {
        type,
        value: type === 'editName' ? editingTitleValue.value.trim() : undefined
      });
    };
    // 保存标题
    const saveTitle = () => {
      if (editingTitleValue.value.trim()) {
        console.log('saveTitle', editingTitleValue.value.trim());
        handleFeature('editName');
      }
      isEditingTitle.value = false;
    };
    // 取消编辑标题
    const cancelEditTitle = () => {
      isEditingTitle.value = false;
    };
    // 获取组合状态
    const getCompositeStatus = state => {
      const {
        makeStatus,
        videoStatus,
        videoMakeProgress
      } = state;
      // 编辑中
      if (videoStatus === 1) return 'editing';
      // 开始生成后的状态
      if (videoStatus === 2) {
        // 生成中
        if (makeStatus === 1) return 'processing';
        // 生成成功
        if (makeStatus === 2) return 'success';
        // 生成失败
        if (makeStatus === 3) return 'error';
      }
      return 'unknown';
    };
    // 替换原有的独立handle方法
    const handlePreview = () => {
      handleFeature('preview');
    };
    const handleClone = () => {
      handleFeature('clone');
    };
    const handleDelete = () => {
      handleFeature('delete');
    };
    const handleDownload = () => {
      handleFeature('download');
    };
    const handleEdit = () => {
      handleFeature('edit');
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_Delete = _resolveComponent("Delete");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "video-cover-container",
        onMouseenter: _cache[6] || (_cache[6] = $event => isHovering.value = true),
        onMouseleave: _cache[7] || (_cache[7] = $event => isHovering.value = false)
      }, [_createElementVNode("div", _hoisted_2, [getCompositeStatus(_ctx.videoItem) === 'error' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_icon, {
        size: 40,
        class: "error-icon"
      }, {
        default: _withCtx(() => [_createVNode(_unref(WarnTriangleFilled))]),
        _: 1
      }), _cache[9] || (_cache[9] = _createElementVNode("span", {
        class: "error-title"
      }, "生成失败", -1)), _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.videoItem.videoMakeFailMessage || '未知错误'), 1)])) : _ctx.videoItem.coverUrl ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: "img-lazy",
        style: _normalizeStyle({
          backgroundImage: `url(${_ctx.videoItem.coverUrl})`,
          backgroundSize: 'cover',
          width: '100%',
          height: '100%',
          transform: 'scale(1.5)'
        })
      }, null, 4)]), _createElementVNode("img", {
        src: _ctx.videoItem.coverUrl,
        alt: _ctx.videoItem.title
      }, null, 8, _hoisted_6)], 64)) : _ctx.videoItem.videoMakeMediaUrl ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_createElementVNode("video", {
        src: _ctx.videoItem.videoMakeMediaUrl,
        preload: "metadata",
        muted: "",
        style: _normalizeStyle({
          zIndex: 1,
          backgroundColor: _ctx.videoItem.backgroundUrl ? 'transparent' : '#131313'
        })
      }, " 您的浏览器不支持 video 标签。 ", 12, _hoisted_7), _ctx.videoItem.backgroundUrl ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", {
        class: "img-lazy",
        style: _normalizeStyle({
          backgroundImage: `url(${_ctx.videoItem.backgroundUrl})`,
          backgroundSize: 'cover',
          width: '100%',
          height: '100%',
          transform: 'scale(1.5)'
        })
      }, null, 4)])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_icon, {
        size: 40,
        class: "empty-icon"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Picture))]),
        _: 1
      }), _cache[10] || (_cache[10] = _createElementVNode("span", null, "暂无封面", -1))])), _ctx.videoItem.videoMakeDuration ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(formatMillisecondsToTimeNoMs)(_ctx.videoItem.videoMakeDuration)), 1)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["hover-mask", {
          'processing': getCompositeStatus(_ctx.videoItem) === 'processing',
          'show-mask': isHovering.value || isPopoverVisible.value,
          'editing-mask': getCompositeStatus(_ctx.videoItem) === 'editing'
        }])
      }, [getCompositeStatus(_ctx.videoItem) === 'success' && _ctx.btnShow.preview ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "play-button-container success-container",
        onClick: handlePreview
      }, _cache[11] || (_cache[11] = [_createElementVNode("div", {
        class: "play-button"
      }, [_createElementVNode("i", {
        class: "ri-play-large-fill",
        style: {
          "margin-left": "3px"
        }
      })], -1), _createElementVNode("p", {
        class: "success-text"
      }, "点击预览视频", -1)]))) : _createCommentVNode("", true), getCompositeStatus(_ctx.videoItem) === 'editing' && _ctx.btnShow.edit ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "play-button-container editing-container",
        onClick: handleEdit
      }, _cache[12] || (_cache[12] = [_createElementVNode("div", {
        class: "play-button editing-button"
      }, [_createElementVNode("i", {
        class: "ri-edit-line"
      })], -1), _createElementVNode("p", {
        class: "editing-text"
      }, "等待编辑制作", -1)]))) : _createCommentVNode("", true), getCompositeStatus(_ctx.videoItem) === 'processing' && _ctx.videoItem.videoMakeProgress ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_cache[15] || (_cache[15] = _createElementVNode("img", {
        src: _imports_0
      }, null, -1)), _createElementVNode("div", _hoisted_13, [_createVNode(_unref(ElText), {
        class: "highlight-text"
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("正在生成视频中...")])),
        _: 1
      })]), _createElementVNode("div", _hoisted_14, [_createVNode(_unref(ElText), {
        class: "tip-text"
      }, {
        default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("精彩视频马上生成，请耐心等待")])),
        _: 1
      })])]), _createVNode(_unref(ElProgress), {
        percentage: _ctx.videoItem.videoMakeProgress,
        indeterminate: false,
        "show-text": true,
        format: p => `${p}%`,
        class: "progress-bar",
        "stroke-width": 18,
        "text-inside": true
      }, null, 8, ["percentage", "format"])])) : _createCommentVNode("", true), getCompositeStatus(_ctx.videoItem) !== 'error' ? (_openBlock(), _createElementBlock("div", _hoisted_15, [getCompositeStatus(_ctx.videoItem) === 'success' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [Object.values(_ctx.btnShow).filter(Boolean).length > 3 ? (_openBlock(), _createBlock(_unref(ElPopover), {
        key: 0,
        placement: "bottom",
        width: 60,
        trigger: "hover",
        "show-arrow": false,
        onShow: _cache[0] || (_cache[0] = $event => isPopoverVisible.value = true),
        onHide: _cache[1] || (_cache[1] = $event => isPopoverVisible.value = false),
        "visible-arrow": false,
        "popper-class": "action-popover"
      }, {
        reference: _withCtx(() => [_createVNode(_unref(ElButton), {
          class: "action-button"
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [_createElementVNode("i", {
            class: "ri-more-2-line"
          }, null, -1)])),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_ctx.btnShow.preview ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "popover-item",
          onClick: handlePreview
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(VideoPlay))]),
          _: 1
        }), _cache[17] || (_cache[17] = _createTextVNode("预览 "))])) : _createCommentVNode("", true), _ctx.btnShow.download ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "popover-item",
          onClick: handleDownload
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Download))]),
          _: 1
        }), _cache[18] || (_cache[18] = _createTextVNode("下载 "))])) : _createCommentVNode("", true), _ctx.btnShow.edit ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "popover-item",
          onClick: handleEdit
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Edit))]),
          _: 1
        }), _cache[19] || (_cache[19] = _createTextVNode("编辑 "))])) : _createCommentVNode("", true), _ctx.btnShow.clone ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "popover-item",
          onClick: handleClone
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(CopyDocument))]),
          _: 1
        }), _cache[20] || (_cache[20] = _createTextVNode("克隆 "))])) : _createCommentVNode("", true), _ctx.btnShow.delete ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "popover-item",
          onClick: handleDelete
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Delete)]),
          _: 1
        }), _cache[21] || (_cache[21] = _createTextVNode("删除 "))])) : _createCommentVNode("", true)])]),
        _: 1
      })) : _createCommentVNode("", true)], 64)) : getCompositeStatus(_ctx.videoItem) === 'editing' ? (_openBlock(), _createBlock(_unref(ElPopover), {
        key: 1,
        placement: "bottom",
        width: 60,
        trigger: "hover",
        "show-arrow": false,
        onShow: _cache[2] || (_cache[2] = $event => isPopoverVisible.value = true),
        onHide: _cache[3] || (_cache[3] = $event => isPopoverVisible.value = false),
        "visible-arrow": false,
        "popper-class": "action-popover"
      }, {
        reference: _withCtx(() => [_createVNode(_unref(ElButton), {
          class: "action-button"
        }, {
          default: _withCtx(() => _cache[22] || (_cache[22] = [_createElementVNode("i", {
            class: "ri-more-2-line"
          }, null, -1)])),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_ctx.btnShow.preview ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "popover-item",
          onClick: handlePreview
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(VideoPlay))]),
          _: 1
        }), _cache[23] || (_cache[23] = _createTextVNode("预览 "))])) : _createCommentVNode("", true), _ctx.btnShow.download ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "popover-item",
          onClick: handleDownload
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Download))]),
          _: 1
        }), _cache[24] || (_cache[24] = _createTextVNode("下载 "))])) : _createCommentVNode("", true), _ctx.btnShow.edit ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "popover-item",
          onClick: handleEdit
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Edit))]),
          _: 1
        }), _cache[25] || (_cache[25] = _createTextVNode("编辑 "))])) : _createCommentVNode("", true), _ctx.btnShow.clone ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "popover-item",
          onClick: handleClone
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(CopyDocument))]),
          _: 1
        }), _cache[26] || (_cache[26] = _createTextVNode("克隆 "))])) : _createCommentVNode("", true), _ctx.btnShow.delete ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "popover-item",
          onClick: handleDelete
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Delete)]),
          _: 1
        }), _cache[27] || (_cache[27] = _createTextVNode("删除 "))])) : _createCommentVNode("", true)])]),
        _: 1
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 2), getCompositeStatus(_ctx.videoItem) === 'error' ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_unref(ElPopover), {
        placement: "bottom",
        width: 60,
        trigger: "hover",
        "show-arrow": false,
        onShow: _cache[4] || (_cache[4] = $event => isPopoverVisible.value = true),
        onHide: _cache[5] || (_cache[5] = $event => isPopoverVisible.value = false),
        "visible-arrow": false,
        "popper-class": "action-popover"
      }, {
        reference: _withCtx(() => [_createVNode(_unref(ElButton), {
          class: "action-button"
        }, {
          default: _withCtx(() => _cache[28] || (_cache[28] = [_createElementVNode("i", {
            class: "ri-more-2-line"
          }, null, -1)])),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_ctx.btnShow.edit ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "popover-item",
          onClick: handleEdit
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Edit))]),
          _: 1
        }), _cache[29] || (_cache[29] = _createTextVNode("编辑 "))])) : _createCommentVNode("", true), _ctx.btnShow.clone ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "popover-item",
          onClick: handleClone
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(CopyDocument))]),
          _: 1
        }), _cache[30] || (_cache[30] = _createTextVNode("克隆 "))])) : _createCommentVNode("", true), _ctx.btnShow.delete ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "popover-item",
          onClick: handleDelete
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Delete)]),
          _: 1
        }), _cache[31] || (_cache[31] = _createTextVNode("删除 "))])) : _createCommentVNode("", true)])]),
        _: 1
      })])) : _createCommentVNode("", true)])], 32)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [isEditingTitle.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_unref(ElInput), {
        modelValue: editingTitleValue.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => editingTitleValue.value = $event),
        size: "small",
        class: "title-input",
        onKeyup: _withKeys(saveTitle, ["enter"])
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_el_icon, {
        class: "confirm-icon",
        onClick: saveTitle
      }, {
        default: _withCtx(() => [_createVNode(_unref(CircleCheck))]),
        _: 1
      }), _createVNode(_component_el_icon, {
        class: "cancel-icon",
        onClick: cancelEditTitle
      }, {
        default: _withCtx(() => [_createVNode(_unref(Close))]),
        _: 1
      })])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.videoItem.name || '无作品名'), 1), getCompositeStatus(_ctx.videoItem) !== 'error' ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 0,
        class: "edit-title-icon",
        onClick: startEditTitle
      }, {
        default: _withCtx(() => [_createVNode(_unref(Edit))]),
        _: 1
      })) : _createCommentVNode("", true)], 64))]), _createElementVNode("div", _hoisted_24, _toDisplayString(formatDate(_ctx.videoItem.createTime)), 1)])], 64);
    };
  }
});